"use client";
import { Skeleton } from "@/app/components/shadcn/skeleton";

const CollectionsSkeleton = () => {
  return (
    <section
      className="border border-muted p-2 sm:p-4 rounded-md"
      style={{
        background:
          "linear-gradient(rgba(255,255,255,0) 10.75%,#fff 85.25%),linear-gradient(88deg,#ffecdf 2.4%,#ffd4c1 50%,#ffd7d7 98.61%)",
      }}
    >
      {/* Header skeleton */}
      <div className="flex items-center justify-between mb-2 sm:mb-3">
        <Skeleton className="h-5 sm:h-6 w-48 sm:w-64" />
        <Skeleton className="h-4 sm:h-5 w-20 sm:w-24" />
      </div>

      {/* Swiper skeleton - matches actual swiper layout */}
      <div className="flex gap-2 overflow-hidden">
        {Array.from({ length: 3 }).map((_, index) => (
          <div
            key={index}
            className="shrink-0 w-[calc(100%-2rem)] sm:w-[calc(50%-0.5rem)] lg:w-[calc(33.333%-0.667rem)] bg-white rounded-lg border border-gray-200 p-3 sm:p-4"
          >
            {/* User info skeleton */}
            <div className="flex items-center gap-2 mb-3">
              <Skeleton className="w-8 h-8 sm:w-10 sm:h-10 rounded-full shrink-0" />
              <div className="flex-1 min-w-0 space-y-1.5">
                <Skeleton className="h-3 sm:h-3.5 w-20 sm:w-24" />
                <Skeleton className="h-2.5 sm:h-3 w-28 sm:w-36" />
              </div>
            </div>

            {/* Images skeleton */}
            <div className="grid grid-cols-3 gap-1 sm:gap-2 mb-3 h-20 sm:h-46.25 rounded-lg overflow-hidden border-2 border-gray-200">
              {Array.from({ length: 3 }).map((_, i) => (
                <Skeleton key={i} className="w-full h-full" />
              ))}
            </div>

            {/* Stats skeleton */}
            <div className="flex items-center gap-1">
              <Skeleton className="h-3 w-12" />
              <Skeleton className="w-1 h-1 rounded-full" />
              <Skeleton className="h-3 w-8" />
              <Skeleton className="w-1 h-1 rounded-full" />
              <Skeleton className="h-3 w-10" />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CollectionsSkeleton;
